import './App.css';
import RecipeCanvas from './recipecanvas.tsx';
import { AbstractChallenge, weightedRandomNumber } from './abstractchallenge.tsx';
import { AbstractCanvasProps } from './abstractcanvas.tsx';
import { INGREDIENTS } from './getIngredients.ts';

interface RecipeData {
  colors: string[];
  nonColorItems: string[];
}

class Recipe extends AbstractChallenge<RecipeData> {
  title() {
    return "Here's a Scrapbook Recipe Challenge for you...";
  }
  
  reloadButtonText(): string {
    return "Generate New Recipe Challenge";
  }

  canvas(props: AbstractCanvasProps<RecipeData>) {
    return <RecipeCanvas {...props} />
  }

  getChallengeData(ingredients: INGREDIENTS): RecipeData {
    let numItems = weightedRandomNumber({2: 0.5, 3: 2, 4: 4, 5: 3, 6: 0.5});
    let hasColor = Math.random() < 0.8;
    let colors = hasColor ? ingredients.getColors(weightedRandomNumber({1:5, 2:3, 3:1}), true):[];
    let nonColorItems = ingredients.pickRandom(numItems - (hasColor?1:0), false, false);
    return {
      colors,
      nonColorItems
    }
  }
}

export default Recipe;
export type {RecipeData};
